import React from 'react';
import { motion } from 'framer-motion';
import './Footer.css';
import imglogo from '../assets/images/qrcode_for_gh_7f0ab11cf846_344.jpg';
const Footer = () => {
  return (
    <motion.footer
      className="footer"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <div className="container">
        <div className="footer-content">
          <motion.div className="footer-section" whileHover={{ y: -5 }}>
            <h4>产品与服务</h4>
            <ul>
              <li><a href="http://filedemo.xingsnb.cn">工程管控系统</a></li>
              <li><a href="/case-studies">成功案例</a></li>
              <li><a href="/product#solutions">解决方案</a></li>
              <li><a href="/product#features">核心功能</a></li>
            </ul>
          </motion.div>
          <motion.div className="footer-section" whileHover={{ y: -5 }}>
            <h4>资源中心</h4>
            <ul>
              <li><a href="/calculation-library">计算库</a></li>
              <li><a href="/ai-qa">AI 问答</a></li>
              <li><a href="#">技术博客</a></li>
              <li><a href="#">帮助文档</a></li>
            </ul>
          </motion.div>
          <motion.div className="footer-section" whileHover={{ y: -5 }}>
            <h4>服务集群</h4>
            <ul>
              <li><a href="http://sdzx.xingsnb.cn">识道咨询 - 专业财税服务专家</a></li>
              <li><a href="http://www.sunsnb.com">昇晟 - AI服务解决专家</a></li>
              <li><a href="http://sdcost.sunsnb.com">识道造价 - 造价领域专家</a></li>
            </ul>
          </motion.div>
          <motion.div className="footer-section" whileHover={{ y: -5 }}>
            <h4>关于我们</h4>
            <ul>
              <li><a href="/about">公司介绍</a></li>
              <li><a href="/contact">联系我们</a></li>
              {/* <li><a href="/careers">加入我们</a></li> */}
              {/* <li><a href="/news">新闻资讯</a></li> */}
            </ul>
            <p>咨询热线: 139-5780-8808</p>
            <p>地址: 宁波市高新区创苑路750号软件园D座8F</p>
          </motion.div>
          <motion.div className="footer-section" whileHover={{ y: -5 }}>
            <h4>关注我们</h4>
            <div className="qr-code">

              <img className='w-full h-full' src={imglogo} alt="" /></div>
            <p>添加星晟公众号获取最新咨询</p>
            {/* <div className="social-links">
              <a href="#" aria-label="微信">.weixin</a>
              <a href="#" aria-label="微博">.weibo</a>
              <a href="#" aria-label="抖音">.douyin</a>
            </div> */}
          </motion.div>
        </div>
        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <p>星晟（宁波）工程数字管理有限公司 浙ICP备2023024133号-1</p>
          <p>© 星晟版权所有</p>
        </motion.div>
      </div>
    </motion.footer>
  );
};

export default Footer;